module.exports = __webpack_public_path__ + "img/u.bcbf77a5.jpg";